import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

const SubscriptionCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen mesh-gradient flex items-center justify-center p-4">
      <div className="bg-card border border-border rounded-2xl p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 bg-slate-800 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-slate-400" />
        </div>
        
        <h1 className="text-2xl font-bold font-['Outfit'] mb-2">
          Pago Cancelado
        </h1>
        
        <p className="text-slate-400 mb-6">
          No te preocupes, puedes actualizar a Premium cuando lo desees. Tu cuenta gratuita sigue activa.
        </p>

        <button
          onClick={() => navigate('/dashboard')}
          className="btn-primary w-full py-3 flex items-center justify-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al Dashboard
        </button>
      </div>
    </div>
  );
};

export default SubscriptionCancelPage;
